export const nbsp = "\u00a0"; // Non-breaking space
